import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '../environments/environments';
import type { CurrencyExchangeApiResponse } from '../models/currency-exchange.models';

@Injectable({ providedIn: 'root' })
export class CurrencyExchangeService {
  readonly #http = inject(HttpClient);

  fetchCurrencyExchange(): Observable<CurrencyExchangeApiResponse> {
    if (environment.useCurrencyExchangeMock) {
      return of(this.#mockCurrencyExchangeResponse());
    }

    const url = `${environment.apiBaseUrl}${environment.currencyExchangePath}`;
    return this.#authorizedGet(url);
  }

  #authorizedGet(url: string): Observable<CurrencyExchangeApiResponse> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
    });
    return this.#http.get<CurrencyExchangeApiResponse>(url, {
      headers,
      withCredentials: true,
    });
  }

  #mockCurrencyExchangeResponse(): CurrencyExchangeApiResponse {
    return [
      {
        dolarPrice: 0.00016644,
        realPrice: 0.0007686395,
        lastUpdate: new Date().toISOString(),
        user: 'mock.user',
      },
    ];
  }
}
